import { useCallback, useMemo } from "react";
import { get } from "lodash";
import { useQuery } from "@tanstack/react-query";

import { queryClient } from "App";
import UserService from "services/User";
import { DIAL_SESSION_CONTACTS_TABLE_CONSTANTS } from "routes/dial_sessions/components/DialSessionsContactTable/DialSessionContactsTableV3";
import { getDialSessionsContactTableColumns } from "routes/dial_sessions/components/DialSessionsContactTable/DialContactsSessionTableColumnsAndFilters";
import { addResizedColumns } from "./useTableConfig";
import { dialSessionContactKeys } from "routes/dial_sessions/components/DialSessionsContactTable/queryKeys";

export const useDialSessionContactsTable = ({ dialSessionId }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: [
      "table-settings-modal",
      DIAL_SESSION_CONTACTS_TABLE_CONSTANTS.queryKey,
    ],
    queryFn: UserService.getUserSettings,
  });

  const queryKey = useMemo(
    () => dialSessionContactKeys.list({ dialSessionId }),
    [dialSessionId]
  );
  const invalidateData = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey });
  }, [queryKey]);

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getDialSessionsContactTableColumns({
      invalidateData,
    });
    const sessionContactsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${DIAL_SESSION_CONTACTS_TABLE_CONSTANTS.queryKey}`,
      {}
    );

    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: sessionContactsTableSettings?.resized_columns || {},
    });
    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched, invalidateData]);
  return { columns, queryKey, invalidateData };
};
